module.exports = __webpack_public_path__ + "media/images/horse_silhouette-44acb096e1b9dd1e945a56a44c942a20.png";